module.exports = __webpack_public_path__ + "static/hero-ffa93b3adee9dc737b1918c73d283040.png";